import { render, staticRenderFns } from "./TmntIndividualStat.vue?vue&type=template&id=a2569922&"
import script from "./TmntIndividualStat.vue?vue&type=script&lang=js&"
export * from "./TmntIndividualStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports